export default __webpack_public_path__ + "static/media/GACMatchmaking 11May FINAL.b5f4a70f.png";